import React from "react";
import { Container, Row, Col } from "reactstrap";

const ServicePage = () => {
  const services = [
    "Reclutamiento y atracción de talento calificado, acorde a las necesidades de tu organización.",
    "Selección por competencias, con aplicación de pruebas psicotécnicas y evaluaciones especializadas.",
    "Estudios de seguridad y visitas domiciliarias, orientados a procesos de selección confiables.",
    "Desarrollo, estructuración e implementación del Sistema de Gestión de Seguridad y Salud en el Trabajo (SG-SST).",
    "Aplicación de la batería de riesgos psicosocial, conforme a la normatividad vigente.",
    "Publicación y gestión de vacantes a través de nuestra plataforma digital.",
    "Afiliaciones a seguridad social para empresas e independientes.",
    "Organización y archivo digital de la información de los empleados.",
    "Outsourcing completo de Gestión Humana, para una administración laboral integral."
  ];

  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="section-title text-center">
                <h3 className="title mb-3">
                  Nuestros servicios
                </h3>
                <p className="text-muted mb-4">
                  ¿Buscas optimizar la gestión de tu personal y fortalecer tu equipo de trabajo?
                  En Avanza Empleo brindamos soluciones integrales en Gestión Humana, diseñadas para apoyar a las empresas en cada etapa del ciclo laboral, garantizando procesos eficientes, confiables y alineados con la normatividad vigente.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={8}>
              <ul className="list-unstyled">
                {services.map((item, key) => (
                  <li key={key} className="d-flex align-items-start mb-3 text-muted">
                    <span className="text-success me-2">✔</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-muted mt-3">
                Con Avanza Empleo, optimizas tiempos y costos, reduces riesgos legales y te enfocas en lo más importante: hacer crecer tu negocio.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ServicePage;
